import React from "react";
import SingleCard from "./SingleCard";
import styled from "styled-components";
import { useState, useEffect, useCallback } from "react";

/* Styled Components 
---------------------------------------------*/

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1em;
  margin: 2em 0 0 0;
`

/* Card Grid Component 
------------------------------------------------*/

const CardGrid = ({ images, setImages, setTurns }) => {
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const resetChoices = useCallback(() => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setDisabled(false);
    setTurns((turns) => turns + 1);
  }, [setTurns]);

  const setImagesCallback = useCallback((updatedImages) => {
    setImages(updatedImages);
  }, [setImages]);

  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        setImagesCallback((images) =>
          images.map((image) => {
            if (image.src === choiceOne.src) {
              return { ...image, flipped: true };
            } else {
              return image;
            }
          })
        );
        resetChoices();
      } else {
        setTimeout(() => {
          resetChoices();
        }, 700);
      }
    }
  }, [choiceOne, choiceTwo, setImagesCallback, resetChoices]);

  const handleOnClick = (card) => {
    if (!disabled) {
      choiceOne !== null ? setChoiceTwo(card) : setChoiceOne(card);
    }
  };

  return (
    <Grid>
      {images.map((value) => (
        <SingleCard
          key={value.index}
          card={value}
          handleOnClick={handleOnClick}
          flipped={choiceOne === value || choiceTwo === value || value.flipped}
        />
      ))}
    </Grid>
  );
};

export default CardGrid;
